<template> </template>

<script>
import * as StoreUtil from "../../util/StoreUtil";
export default {
  name: "ExitAlert",
  mounted() {
    window.addEventListener(
      "beforeunload",
      function(e) {
        if (StoreUtil.isModeDraw() && !StoreUtil.isNeedReload()) {
          e.returnValue = "お絵かき中ですが、リロードしますか？";
        }
      },
      false
    );
  }
};
</script>
